<template>
  <div class="loading-dialog-wrapper" v-if="visible">
    <div class="loading-dialog-mask"></div>
    <div class="loading-dialog-content">
      <div class="loading-animation">
        <div class="loading-spinner"></div>
        <div class="loading-text">{{ loadingText }}</div>
      </div>
      <!-- <div class="progress-container" v-if="showProgress">
        <div class="progress-bar" :style="{width: progress + '%'}"></div>
        <div class="progress-text">{{ progress }}%</div>
      </div> -->
      <!-- <button class="stop-button" @click="handleStop">{{ stopButtonText }}</button> -->
    </div>
  </div>
</template>

<script>
import api from '@/api/api'
export default {
  name: 'LoadingRecall',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: '长记忆任务执行中，请稍候...'
    },
    stopButtonText: {
      type: String,
      default: '取消记忆'
    },
    progress: {
      type: Number,
      default: 0
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    novelType: String,
    novelId: String | Number
  },
  methods: {
    handleStop() {
      let data = {
        novelId: this.novelId,
        type: this.novelType
      }
      api.recallStop(data).then(res => {
        if (res.code === 200) {
           this.$message.success('已取消长记忆！')
           this.$emit('update:visible',false);
        } else {
          this.$message.warning(res.msg)
        }
      })
      
    }
  }
};
</script>

<style scoped>
.loading-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.loading-dialog-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.loading-dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
}

.loading-animation {
  margin-bottom: 20px;
}

.loading-spinner {
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  color: #606266;
  font-size: 14px;
}

.progress-container {
  width: 100%;
  height: 6px;
  background-color: #ebeef5;
  border-radius: 3px;
  margin-bottom: 15px;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #409eff;
  border-radius: 3px;
  transition: width 0.3s;
}

.progress-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.stop-button {
  padding: 8px 20px;
  background-color: #f56c6c;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.stop-button:hover {
  background-color: #f78989;
}
</style>
